<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogIsVisible"
      :append-to-body="true"
      @close="oncancel"
    >
      <el-form :model="MasiveIncomeForm" ref="MasiveIncomeForm">
        <el-row>
          <!-- <el-form-item label="Nomina" prop="NominaName">
            <el-input
              v-model="MasiveIncomeForm.NominaName"
              :disabled="true"
              width="50"
            >
            </el-input>
          </el-form-item> -->
          <el-form-item
            label="Empleados"
            prop="Employee"
            v-if="onlyEmployee == false"
          >
            <!--
            <el-select v-model="MasiveIncomeForm.Employee" multiple>
                <el-option
                v-for="item in Employees"
                :key="item.id"
                :label="item.description"
                :value="item.types"
                >
                </el-option>
            </el-select>
            -->
            <!--
            <el-table
              ref="employeeTable"
              :data="EmployeesFiltered"
              :max-height="300"
              @selection-change="handleEmployeeSelected"
              @select="onEmployeeSelected"
            >
              <el-table-column type="selection" with="50"></el-table-column>
              <el-table-column label="Nombre" prop="Name"></el-table-column>
              <el-table-column
                label="Posicion"
                prop="Posicion.Name"
              ></el-table-column>
              <el-table-column label="Direccion" prop="Direccion.Name">
                <template slot="header">
                  <el-input
                    v-model="search"
                    size="mini"
                    placeholder="Filtrar Nombre Empleado"
                  ></el-input>
                </template>
              </el-table-column>
            </el-table>
            -->
            <el-transfer
              filterable
              :filter-method="filterMethod"
              filter-placeholder="State Abbreviations"
              v-model="AddedEmployees"
              :data="DataForTransfer"
              :titles="['Empeados', 'Seleccionados']"
              :button-texts="['Quitar', 'Agregar']"
            >
            </el-transfer>
          </el-form-item>
          <div v-else>
            <el-row>
              <el-form-item label="Nombre" prop="Nombre">
                <el-input v-model="GetEmployeeName" :disabled="true">
                </el-input>
              </el-form-item>
            </el-row>
          </div>
        </el-row>
        <!-- <el-row> -->
        <!-- <el-col :span="10"> -->
        <el-row>
          <el-col :span="9">
            <el-form-item label="Tipo de Ingreso" prop="IncomeType">
              <el-select v-model="MasiveIncomeForm.IncomeType" size="small">
                <el-option
                  v-for="item in IncomesTypes"
                  :key="item.id"
                  :label="item.description"
                  :value="item.types"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Monto" prop="amount">
              <el-input-number
                v-model="MasiveIncomeForm.amount"
                :precision="2"
                :controls="false"
                size="small"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <!-- </el-col>
            <el-col :offset="1" :span="10"> -->
          <!-- </el-col> -->
          <!-- </el-row> -->
          <!--
        <el-form-item label="Quincena:" prop="isBiweekly">
          <el-radio-group v-model="MasiveIncomeForm.isBiweekly">
            <el-radio :label="1">1ra Quincena</el-radio>
            <el-radio :label="2">2da Quincena</el-radio>
          </el-radio-group>
        </el-form-item>
        -->
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="Es recurrente?" prop="recurrency">
              <el-switch
                v-model="MasiveIncomeForm.recurrency"
                active-text="Si"
                inactive-text="No"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item
              v-if="MasiveIncomeForm.recurrency === false"
              label="Fecha"
              prop="month"
            >
              <el-date-picker
                v-model="MasiveIncomeForm.month"
                type="month"
                placeholder="Mes"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              v-if="MasiveIncomeForm.recurrency === true"
              label="Fecha"
              prop="dateRange"
            >
              <el-date-picker
                v-model="MasiveIncomeForm.dateRange"
                type="daterange"
                range-separator="|"
                start-placeholder="Desde"
                end-placeholder="Hasta"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="Aplicable">
              <el-radio-group v-model="MasiveIncomeForm.Biweekly">
                <el-radio-button label="1">1ra Quincena</el-radio-button>
                <el-radio-button label="2">2da Quincena</el-radio-button>
                <el-radio-button label="0">Ambas</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button type="info" @click="oncancel">Cancelar</el-button>
        <el-button type="primary" @click="ApplyIncomes">Aplicar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "MasiveIncomeDiscount",

  props: {
    IncomesDiscountType: {
      type: String,
      default: ""
    },
    isVisible: {
      type: Boolean,
      default: false
    },
    NominaData: {
      type: Object,
      default: () => {}
    },
    nominasData: {
      type: Array,
      default: () => []
    },
    NominaName: {
      type: String,
      default: ""
    },
    NominaId: {
      type: Number,
      default: 0
    },
    Employee: {
      type: Array,
      default: () => []
    },
    onlyEmployee: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      MasiveIncomeForm: {
        IncomeType: "",
        Employee: [],
        amount: 0,
        isBiweekly: false,
        recurrency: false,
        Biweekly: "1",
        month: "",
        dateRange: [],
        NominaName: ""
      },
      IncomesTypes: [],
      Employees: [],
      EmployeesSelected: [],
      DataForTransfer: [],
      AddedEmployees: [],
      EmployeesSelectedCounter: 0,
      search: "",
      dialogTitle: ""
    };
  },
  mounted() {
    //this.MasiveIncomeForm.NominaName = this.nominasData[0].Nomina.Name

    if (this.IncomesDiscountType === "income") {
      this.dialogTitle = "Aplicacion de Ingreso";
      this.GetIncomesTypes();
    } else if (this.IncomesDiscountType === "discount") {
      this.dialogTitle = "Aplicacion de Descuentos";
      this.GetDiscountsTypes();
    }

    if (this.isEdit) {
      const dateFrom = new Date(this.NominaData.dateFrom);
      const dateTo = new Date(this.NominaData.dateTo);

      if (this.IncomesDiscountType === "income") {
        this.MasiveIncomeForm.IncomeType = this.NominaData.income_Type;
        this.MasiveIncomeForm.Employee.push(this.NominaData.Employee);
        this.MasiveIncomeForm.amount = this.NominaData.income_amount;
        this.MasiveIncomeForm.Biweekly = this.NominaData.Biweekly;
        this.MasiveIncomeForm.recurrency = this.NominaData.isRecurrent;
        this.MasiveIncomeForm.dateRange.push(dateFrom, dateTo);
      } else if (this.IncomesDiscountType === "discount") {
        this.IncomesDiscountType === "discount";
      }
    }
    this.GetEmployees();
  },
  /*
  updated() {
    if (this.isEdit) {
      const dateFrom = new Date(this.NominaData.dateFrom);
      const dateTo = new Date(this.NominaData.dateTo);

      if (this.IncomesDiscountType === "income") {
        this.MasiveIncomeForm.IncomeType = this.NominaData.income_Type;
        this.MasiveIncomeForm.Employee.push(this.NominaData.Employee);
        this.MasiveIncomeForm.amount = this.NominaData.income_amount;
        this.MasiveIncomeForm.Biweekly = this.NominaData.Biweekly;
        this.MasiveIncomeForm.recurrency = this.NominaData.isRecurrent;
        this.MasiveIncomeForm.dateRange.push(dateFrom, dateTo);
      } else if (this.IncomesDiscountType === "discount") {
        this.IncomesDiscountType === "discount"
      }
    }
  },
  */
  computed: {
    GetEmployeeName() {
      let name = "";
      if (this.isEdit) {
        name = this.NominaData.Employee.FullName;
      } else {
        name = this.Employee[0].Nombre;
      }

      return name;
    },
    dialogIsVisible() {
      return this.isVisible;
    },
    NominaDetailData() {
      return this.nominasData;
    },
    getIncomeTypes() {
      return this.IncomesDiscountType;
    },
    EmployeesFiltered() {
      let employeesSelected = this.Employees.filter(
        (emp) =>
          emp.Name.toLowerCase().includes(
            this.search.toLowerCase()
          ) /*|| emp.ID.toLowerCase().includes(this.search.toLowerCase)*/
      );

      return employeesSelected;
    }
  },
  methods: {
    oncancel() {
      this.$refs.MasiveIncomeForm.resetFields();
      this.$emit("Canceled");
    },
    async GetEmployees() {
      await this.$http
        .get("/api/Employees/GetAllEmployee", {
          params: {
            companyID: this.currentCompany
          }
        })
        .then((resp) => {
          this.Employees = resp.data;
          this.TransforDataForTransfer(resp.data);
        });
    },
    TransforDataForTransfer(employees) {
      this.DataForTransfer = [];
      employees.forEach((employ) => {
        this.DataForTransfer.push({
          label: employ.Name,
          key: employ.ID
        });
      });
    },
    async GetIncomesTypes() {
      await this.$http.get("/api/Payroll/GetIcomesTypes").then((response) => {
        this.IncomesTypes = response.data;
      });
    },
    async GetDiscountsTypes() {
      this.$http.get("/api/Payroll/GetDiscountsTypes").then((response) => {
        this.IncomesTypes = response.data;
      });
    },
    onEmployeeSelected(selection) {
      if (selection.length > 0) {
        selection.forEach((employee) => {
          this.EmployeesSelected.push(employee);
        });
      } else {
        //this.EmployeesSelected = [];
      }
    },
    handleEmployeeSelected(employees) {
      this.MasiveIncomeForm.Employee = employees;
    },
    ToggleEmployeeSelection() {
      this.EmployeesSelected.forEach((employee) => {
        this.$refs.employeeTable.toggleRowSelection(employee);
      });
    },
    async ApplyIncomes() {
      if (this.isEdit) {
        const params = {
          Id: this.NominaData.Id,
          employee_Id: this.NominaData.employee_Id,
          incomeDiscount_Type: this.MasiveIncomeForm.IncomeType,
          incomeDiscount_amount: this.MasiveIncomeForm.amount,
          isRecurrent: this.MasiveIncomeForm.recurrency,
          Biweekly: this.MasiveIncomeForm.Biweekly,
          dateRange: this.MasiveIncomeForm.dateRange,
          created_At: this.NominaData.created_At,
          Nomina_Id: this.NominaData.Nomina_Id,
          isPayed: this.NominaData.isPayed,
          month: this.MasiveIncomeForm.month
        };
        if (this.MasiveIncomeForm.recurrency === false) {
          const dateNow = new Date();
          params.dateRange = [dateNow, dateNow];
        }

        if (this.IncomesDiscountType === "income") {
          await this.$http
            .put("/api/Payroll/EditIncomes", params)
            .then(() => {})
            .catch((err) => {
              console.error(err);
            })
            .finally(() => {
              this.$emit("ClosingMasiveIncomeDiscount");
            });
        } else if (this.IncomesDiscountType === "discount") {
          await this.$http
            .put("/api/Payroll/EditDiscount", params)
            .then(() => {})
            .catch((err) => {
              console.error(err);
            })
            .finally(() => {
              this.$emit("ClosingMasiveIncomeDiscount");
            });
        }
      } else {
        if (this.onlyEmployee == true)
          this.MasiveIncomeForm.Employee = this.Employee;

        const params = {
          employee_Ids: this.AddedEmployees, //this.MasiveIncomeForm.Employee.map((emp) => emp.ID),
          incomeDiscount_Type: this.MasiveIncomeForm.IncomeType,
          incomeDiscount_amount: this.MasiveIncomeForm.amount,
          isRecurrent: this.MasiveIncomeForm.recurrency,
          Nomina_Id: this.NominaDetailData[0].Nomina.Id ?? 0,
          Biweekly: this.MasiveIncomeForm.Biweekly,
          /*
            this.MasiveIncomeForm.recurrency === true
              ? this.MasiveIncomeForm.Biweekly
              : this.NominaDetailData[0].Nomina.Biweekly,
              */
          dateRange: this.MasiveIncomeForm.dateRange,
          month: this.MasiveIncomeForm.month
        };

        if (this.MasiveIncomeForm.recurrency === false) {
          const dateNow = new Date();
          params.dateRange = [dateNow, dateNow];
        }

        const dateRageStart = params.dateRange[0].toDateString();
        const dateRageEnd = params.dateRange[1].toDateString();

        if (
          dateRageStart == dateRageEnd &&
          this.MasiveIncomeForm.recurrency === true
        ) {
          this.$message({
            type: "error",
            message: "La fecha de inicio y fin no pueden ser iguales"
          });

          return;
        }
        if (this.IncomesDiscountType === "income") {
          await this.$http
            .post("/api/Payroll/insertMasiveIncomes", params)
            .finally(() => {
              this.$emit(
                "ClosingMasiveIncomeDiscount",
                this.NominaDetailData[0].Nomina
              );
            });
        } else if (this.IncomesDiscountType === "discount") {
          await this.$http
            .post("/api/Payroll/insertMasiveDiscounts", params)
            .finally(() => {
              this.$emit(
                "ClosingMasiveIncomeDiscount",
                this.NominaDetailData[0].Nomina
              );
            });
        }
      }

      this.$refs.MasiveIncomeForm.resetFields();
    }
  },
  watch: {
    dialogIsVisible(val) {
      if (val === true) {
        if (this.IncomesDiscountType === "income") {
          this.GetIncomesTypes();
        } else if (this.IncomesDiscountType === "discount") {
          this.GetDiscountsTypes();
        }
        this.GetEmployees();
      }
      //this.MasiveIncomeForm.NominaName = this.NominaDetailData[0].Nomina.Name;
    },
    search() {
      this.ToggleEmployeeSelection();
    },
    /*
    NominaDetailData(val) {
    },
    */
    getIncomeTypes(val) {
      if (val === "income") {
        this.dialogTitle = "Aplicacion de Ingreso";
        this.GetIncomesTypes();
      } else if (val === "discount") {
        this.dialogTitle = "Aplicacion de Descuentos";
        this.GetDiscountsTypes();
      }
    },
    NominaData() {
      if (this.isEdit) {
        const dateFrom = new Date(this.NominaData.dateFrom);
        const dateTo = new Date(this.NominaData.dateTo);

        if (this.IncomesDiscountType === "income") {
          this.MasiveIncomeForm.IncomeType = this.NominaData.income_Type;
          this.MasiveIncomeForm.Employee.push(this.NominaData.Employee);
          this.MasiveIncomeForm.amount = this.NominaData.income_amount;
          this.MasiveIncomeForm.Biweekly = this.NominaData.Biweekly;
          this.MasiveIncomeForm.recurrency = this.NominaData.isRecurrent;
          this.MasiveIncomeForm.dateRange.push(dateFrom, dateTo);
        } else if (this.IncomesDiscountType === "discount") {
          this.MasiveIncomeForm.IncomeType = this.NominaData.discount_Type;
          this.MasiveIncomeForm.Employee.push(this.NominaData.Employee);
          this.MasiveIncomeForm.amount = this.NominaData.discount_amount;
          this.MasiveIncomeForm.Biweekly = this.NominaData.Biweekly;
          this.MasiveIncomeForm.recurrency = this.NominaData.isRecurrent;
          this.MasiveIncomeForm.dateRange.push(dateFrom, dateTo);
        }
      }
    }
  }
};
</script>

<style></style>
